<template>
    <div id="app">
        <router-view class='main-page'></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    props: {
        firstRouter: {
            type: Object
        }
    },
    created(){

    },
    mounted() {
        // console.log("this.firstRouter.path",this.firstRouter.path);  //我打印了  不走这
        // if (this.firstRouter.path !== "/") {
        //     this.$router.replace(Object.assign({}, this.firstRouter));
        // }else{
        //     //未来的登陆页
        //     this.$router.replace({
        //         path: "/login.html",
        //         query: {},
        //     })
        // }
        
    },
    methods:{}
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
.main_page{
    /* width: 100%;
    height: 100%; */
}
html,body,#app{
    width:100%;
    height: 100%;
    overflow-x: hidden;
     /*background: url("../static/img/bg-min.png") no-repeat;*/
     /*background-size: 100% 100%; */
    /*background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png") no-repeat;*/
    /*background-size: 100% 100%;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue